import { Map } from 'immutable';

import { ANSWERS__GET, ANSWERS__POST } from '../constants';
import { mergeJsonArray } from '../../util';

const defaultState = new Map();

export default function (state = defaultState, action) {
  switch (action.type) {
    case ANSWERS__POST: {
      window.scrollTo(0, 0);
      return state;
    }
    case ANSWERS__GET: {
      return mergeJsonArray(state, action.data);
    }
    default:
      return state;
  }
}
